import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { delay, indexOf } from 'lodash';
import { AgGridReact } from 'ag-grid-react';
import { Button } from 'react-bootstrap';

import Fa from 'react-fontawesome';
import SearchField from '../../../../components/search-field';
import ProgressBar from '../../../../components/progress-bar';
import { fetchAllTeams, deleteTeam, updateTeam } from '../../TeamActions';

import { getAllTeams } from '../../TeamReducer';
import TeamModal from '../../components/TeamModal';
import LabelCellRenderer from '../../components/table-cells/TeamNameRenderer';
import { getUser, getCanSetupOrganization, getUserCurrentOrganization } from '../../../Auth/AuthReducer';
import ShareModal from '../../components/ShareModal';
import ActionRenderer from '../../../../components/table-cells/ActionRenderer';
import DefaultCellRenderer from '../../components/table-cells/DefaultTeamRenderer';
import GlobalCellRenderer from '../../components/table-cells/GlobalTeamRenderer';
import MoneyRenderer from '../../../../components/table-cells/MoneyRenderer';

class TeamIndexPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loaded: false,
      deletingTeams: [], // array of ids
      editingTeam: null,
      updatingTeams: [], // array of ids
      showModal: false,
      sharingTeam: null,
      showShareModal: false,
    };
    this.onGridReady = this.onGridReady.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.onFirstDataRendered = this.onFirstDataRendered.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
    this.handleModalClose = this.handleModalClose.bind(this);
    this.handleShareModalClose = this.handleShareModalClose.bind(this);
    this.handleSuccess = this.handleSuccess.bind(this);
    this.handleRequestShare = this.handleRequestShare.bind(this);
    this.handleShareSuccess = this.handleShareSuccess.bind(this);
    this.requestUpdateTeam = this.requestUpdateTeam.bind(this);
    this.actionColumnCellRendererSelector = this.actionColumnCellRendererSelector.bind(this);
    this.handleMenuAction = this.handleMenuAction.bind(this);
    this.extraActionMenu = [
      { id: 'share', label: (<span><Fa name="share" /> Share</span>) }
    ];
  }

  componentDidMount() {
    this.loadTeams();
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  onFirstDataRendered() {
    if (this.gridApi && this.gridColumnApi) {
      this.gridApi.sizeColumnsToFit();
    }
  }

  actionColumnCellRendererSelector(params) {
    if (!params || !params.data) {
      return null;
    }
    const { deletingTeams, updatingTeams } = this.state;
    const team = params.data;

    const deleting = indexOf(deletingTeams, team._id) >= 0;
    const updating = indexOf(updatingTeams, team._id) >= 0;
    const isMyTeam = params.data.is_my_team === true;
    const canManage = params.data.can_manage === true;

    return {
      params: {
        header: `Team: ${team.name}`,
        deleting,
        updating,
        canEdit: canManage,
        canDelete: isMyTeam,
        requestEdit: this.handleEdit,
        requestDelete: this.handleDelete,
        handleMenuAction: this.handleMenuAction,
        menu: this.extraActionMenu,
      },
      component: ActionRenderer,
    };
  }

  handleMenuAction(menu, data) {
    if (menu && menu.id === 'share') {
      this.handleRequestShare(data);
    }
  }

  handleEdit(team) {
    const { deletingTeams } = this.state;
    if (indexOf(deletingTeams, team._id) < 0) {
      this.setState({ editingTeam: team, showModal: true });
    }
  }

  handleSuccess(team, isNew) {
    const { teams } = this.props;
    if (teams.length === 1 && isNew) {
      this.context.router.history.push(`teams/${team._id}`);
    } else {
      delay(() => {
        this.onFirstDataRendered();
      }, 500);
    }
  }

  handleShareSuccess() {
    // TODO: display success in toast?
  }

  handleDelete(team) {
    const { deletingTeams } = this.state;
    if (indexOf(deletingTeams, team._id) < 0) {
      const newDeletingTeams = [...deletingTeams];
      newDeletingTeams.push(team._id);
      this.setState({ deletingTeams: newDeletingTeams }, () => {
        this.props.dispatch(deleteTeam(team._id))
          .then(
            () => {
              this.setState({ deletingTeams: [...deletingTeams] });
            },
            () => {
              this.setState({ deletingTeams: [...deletingTeams] });
            },
          );
      });
    }
  }

  handleSearch(query) {
    if (this.gridApi) {
      this.gridApi.setQuickFilter(query);
    }
  }

  handleRequestShare(team) {
    const { deletingTeams } = this.state;
    if (indexOf(deletingTeams, team._id) < 0) {
      this.setState({ sharingTeam: team, showShareModal: true });
    }
  }

  handleModalClose() {
    this.setState({ showModal: false });
  }

  handleShareModalClose() {
    this.setState({ showShareModal: false });
  }

  requestUpdateTeam(team) {
    const { updatingTeams } = this.state;
    if (indexOf(updatingTeams, team._id) < 0) {
      const newUpdatingTeams = [...updatingTeams];
      newUpdatingTeams.push(team._id);
      this.setState({ updatingTeams: newUpdatingTeams }, () => {
        this.props.dispatch(updateTeam(team._id, { name: team.name, is_default: !team.is_default }))
          .then(
            () => {
              this.setState({ updatingTeams: [...updatingTeams] }, () => {

              });
            },
            () => {
              this.setState({ updatingTeams: [...updatingTeams] });
            },
          );
      });
    }
  }

  loadTeams() {
    this.setState({ loading: true, loaded: false });
    this.props.dispatch(fetchAllTeams())
      .then(
        () => {
          this.setState({ loading: false, loaded: true }, () => {
            delay(() => {
              this.onFirstDataRendered();
            }, 500);
          });
        },
        () => {
          // TODO: display error in toast
          this.setState({ loading: false, loaded: false });
        },
      );
  }

  renderTable() {
    const { teams, salesGoal } = this.props;

    const defaultColDef = {
      suppressMenu: true,
      suppressMovable: true,
      resizable: true,
      sortable: true,
      suppressColumnsToolPanel: true,
      suppressFiltersToolPanel: true,
    };

    const columnDefs = [
      {
        headerName: 'Team',
        field: 'name',
        colId: 'LABEL',
        pinned: 'left',
        cellRenderer: LabelCellRenderer,
        suppressMovable: true,
        suppressColumnsToolPanel: true,
        suppressFiltersToolPanel: true,
        // minWidth: 200,
        cellRendererParams: {
          deletingTeams: this.state.deletingTeams,
          user: this.props.user,
        },
      },
      {
        headerName: 'Description',
        field: 'description',
        colId: 'DESCRIPTION',
        width: 200,
        sortable: false,
        type: 'numericColumn',
      },
      ...(salesGoal ? [{
        headerName: 'Annual Sales Goal',
        field: 'annual_sales_goal',
        colId: 'SALES_GOAL',
        suppressMenu: true,
        sortable: true,
        suppressMovable: true,
        suppressColumnsToolPanel: true,
        suppressFiltersToolPanel: true,
        cellClass: 'text-right',
        cellRenderer: MoneyRenderer,
        cellRendererParams: {
          precision: 2,
        },
      }] : []),
      {
        headerName: 'Type',
        field: 'is_global',
        colId: 'ISGLOBAL',
        cellRenderer: GlobalCellRenderer,
        suppressMovable: true,
        suppressColumnsToolPanel: true,
        suppressFiltersToolPanel: true,
        // minWidth: 60,
      },
      {
        headerName: 'Is Default',
        field: 'is_default',
        colId: 'DEFAULT',
        cellRenderer: DefaultCellRenderer,
        suppressMovable: true,
        suppressColumnsToolPanel: true,
        suppressFiltersToolPanel: true,
        // minWidth: 60,
        cellRendererParams: {
          deletingTeams: this.state.deletingTeams,
          updatingTeams: this.state.updatingTeams,
          requestUpdateTeam: this.requestUpdateTeam,
        },
      },
      {
        headerName: 'Actions',
        field: '_id',
        colId: 'ACTION',
        pinned: 'right',
        sortable: false,
        suppressMovable: true,
        suppressColumnsToolPanel: true,
        suppressFiltersToolPanel: true,
        width: 100,
        cellRendererSelector: this.actionColumnCellRendererSelector,
      },
    ];
    return (
      <div>
        <nav className="navbar navbar-default navbar-controls">
          <div className="clearfix">
            <form className="navbar-form navbar-right" style={{ paddingRight: 30 }}>
              <Button
                bsStyle="primary"
                onClick={() => this.setState({ editingTeam: {}, showModal: true })}
              >
                <Fa name="plus" /> Add new Team
              </Button>
            </form>
            <form className="navbar-form navbar-left">
              <SearchField collapsible={false} onSearch={this.handleSearch} />
            </form>
          </div>
        </nav>

        <div className="ag-theme-alpine" style={{ width: '100%', border: '1px solid #fff' }}>
          <AgGridReact
            reactNext
            animateRows
            domLayout="autoHeight"
            suppressColumnVirtualisation
            columnDefs={columnDefs}
            defaultColDef={defaultColDef}
            getRowNodeId={data => data._id}
            onGridReady={this.onGridReady}
            onFirstDataRendered={this.onFirstDataRendered}
            rowData={teams}
          />
        </div>
      </div>
    )
  }

  renderContent() {
    const { teams } = this.props;
    return (
      <div>
        <div className="clearfix">
          <h1 className="page-header">
            All Teams
          </h1>
        </div>
        {teams.length === 0 &&
          <div>
            <Button bsStyle="primary" onClick={() => this.setState({ editingTeam: {}, showModal: true })}>
              <Fa name="plus" /> Add New Team
            </Button>
          </div>
        }
        {teams.length > 0 && this.renderTable()}
      </div>
    );
  }

  render() {
    const {
      loading, loaded, editingTeam, showModal, showShareModal,
      sharingTeam,
    } = this.state;
    const { salesGoal } = this.props;
    const isLoading = loading || !loaded;
    return (
      <div>
        {isLoading && <ProgressBar />}
        {!isLoading && this.renderContent()}
        <TeamModal
          show={showModal}
          team={editingTeam}
          onClose={this.handleModalClose}
          onSuccess={this.handleSuccess}
          showSalesGoal={salesGoal}
        />
        <ShareModal
          show={showShareModal}
          team={sharingTeam}
          onClose={this.handleShareModalClose}
          onSuccess={this.handleShareSuccess}
        />
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state) {
  const organization = getUserCurrentOrganization(state);
  return {
    teams: getAllTeams(state),
    canShare: getCanSetupOrganization(state),
    user: getUser(state),
    salesGoal: organization.annual_sales_goals === true,
  };
}

TeamIndexPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  canShare: PropTypes.bool.isRequired,
  user: PropTypes.shape({
    _id: PropTypes.string.isRequired,
  }).isRequired,
  teams: PropTypes.arrayOf(PropTypes.shape({
    _id: PropTypes.string,
    name: PropTypes.string,
    description: PropTypes.string,
  })),
  salesGoal: PropTypes.bool,
};

TeamIndexPage.defaultProps = {
  teams: [],
  salesGoal: false,
};

TeamIndexPage.contextTypes = {
  router: PropTypes.shape({}),
};

export default connect(mapStateToProps)(TeamIndexPage);
